import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature21',
      playScale: 0.3,
      always: false,
    },
    title: {
      className: 'feature21-title',
      main: {
        className: 'feature21-title-main',
        children: '产业优势',
      },
      second: {
        className: 'feature21-title-second',
        children: '1+3+3+1 产业体系',
      },
    },
    content: {
      className: 'feature21-content',
      children: [
        {
          name: 'item0',
          className: 'feature21-content-item',
          children: '',
          img: {
            className: 'feature21-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/images/olav-tvedt--oVaYMgBMbs-unsplash%402x.png',
          },
          icon: {
            className: 'feature21-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/images/feature21-3.png',
          },
          title: {
            className: 'feature21-content-item-title',
            children: [
              {
                name: 'text0',
                className: 'feature21-content-item-title-text',
                children: '汽车产业',
              },
            ],
          },
        },
        {
          name: 'item1',
          className: 'feature21-content-item',
          children: '',
          img: {
            className: 'feature21-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/images/olav-tvedt--oVaYMgBMbs-unsplash%402x(1).png',
          },
          icon: {
            className: 'feature21-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/images/feature21-2.png',
          },
          title: {
            className: 'feature21-content-item-title',
            children: [
              {
                name: 'text0',
                className: 'feature21-content-item-title-text',
                children: '战略新兴产业',
              },
            ],
          },
        },
        {
          name: 'item2',
          className: 'feature21-content-item',
          children: '',
          img: {
            className: 'feature21-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/images/olav-tvedt--oVaYMgBMbs-unsplash%402x(2).png',
          },
          icon: {
            className: 'feature21-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/images/feature21-1.png',
          },
          title: {
            className: 'feature21-content-item-title',
            children: [
              {
                name: 'text0',
                className: 'feature21-content-item-title-text',
                children: '现代服务业',
              },
            ],
          },
        },
        {
          name: 'item3',
          className: 'feature21-content-item',
          children: '',
          img: {
            className: 'feature21-content-item-img',
            children:
              'https://imm.86links.com/assets/landing/images/olav-tvedt--oVaYMgBMbs-unsplash%402x(3).png',
          },
          icon: {
            className: 'feature21-content-item-icon',
            children:
              'https://imm.86links.com/assets/landing/images/feature21-4.png',
          },
          title: {
            className: 'feature21-content-item-title',
            children: [
              {
                name: 'text0',
                className: 'feature21-content-item-title-text',
                children: '新经济',
              },
            ],
          },
        },
      ],
    },
  },
};
